import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'pregunta-verdadero-falso',
  templateUrl: 'pregunta-verdadero-falso.html'
})
export class PreguntaVerdaderoFalsoComponent {

  @Input() preguntaActual: any;
  @Input() respuestaActual: any;
  @Input() enEsperaRespuesta: boolean;
  @Output() handleRespuesta = new EventEmitter<any>();

  constructor() { }

  _handleRespuesta(opcion, index) {
    this.handleRespuesta.emit({opcion, index});
  }

  obtenRespuestaCorrecta() {
    if(!this.preguntaActual) return '';

    return this.preguntaActual.opciones.find( o => o.esCorrecta ).respuesta;
  }

  respuestaCorrecta() {
    if(!this.preguntaActual) return '';

    return this.preguntaActual.opciones.find( o => o.esCorrecta );
  }

  respuestaIncorrecta() {
    if(!this.preguntaActual) return '';

    return this.preguntaActual.opciones.find( o => !o.esCorrecta );
  }

}



// WEBPACK FOOTER //
// ./src/components/pregunta-verdadero-falso/pregunta-verdadero-falso.ts